/**
 * M.S.A. (Marta Support Assistant) Configuration
 *
 * Agent for support request triage, pattern detection and resolution suggestions
 */

import type { AIAgent } from '../types.js';

export const MSA_AGENT_ID = 'msa';
export const MSA_AGENT_VERSION = '1.0.0';

export const MSA_AGENT: AIAgent = {
  id: MSA_AGENT_ID,
  name: 'Marta Support Assistant',
  description: 'Triages support requests, detects error patterns and suggests resolutions',
  version: MSA_AGENT_VERSION,
  enabled: true,

  capabilities: [
    {
      id: 'triage-request',
      name: 'Triage Support Request',
      description: 'Analyzes support request content to assign priority and category',
      inputSchema: {
        type: 'object',
        properties: {
          title: { type: 'string' },
          description: { type: 'string' },
          source: { type: 'string' },
        },
        required: ['title', 'description'],
      },
      outputSchema: {
        type: 'object',
        properties: {
          priority: { type: 'string', enum: ['low', 'medium', 'high', 'critical'] },
          category: { type: 'string' },
          suggestedAssignee: { type: 'string' },
          autoResolvable: { type: 'boolean' },
        },
      },
    },
    {
      id: 'detect-patterns',
      name: 'Detect Error Patterns',
      description: 'Analyzes client logs and support requests to detect recurring issues',
      inputSchema: { type: 'object', properties: {} },
      outputSchema: {
        type: 'object',
        properties: {
          patterns: { type: 'array' },
          totalLogs: { type: 'number' },
          criticalCount: { type: 'number' },
        },
      },
    },
    {
      id: 'suggest-resolution',
      name: 'Suggest Resolution',
      description: 'Suggests resolution steps based on similar past issues',
      inputSchema: {
        type: 'object',
        properties: {
          requestId: { type: 'string' },
          errorMessage: { type: 'string' },
        },
      },
      outputSchema: {
        type: 'object',
        properties: {
          suggestions: { type: 'array', items: { type: 'string' } },
          similarIssues: { type: 'array' },
          confidence: { type: 'number' },
        },
      },
    },
  ],

  workflows: ['support-triage', 'error-pattern-detection', 'auto-resolution'],
  triggers: [
    'entity.created/support_request',
    'entity.created/client_log',
    'entity.updated/support_request',
  ],

  metrics: { totalCalls: 0, successRate: 0, avgLatencyMs: 0, correctionRate: 0 },
  trainingDataCount: 0,
  lastTrainedAt: undefined,
};

export const MSA_SETTINGS = {
  model: 'llama-3.3-70b-versatile',
  maxTokens: 400,
  patternMinOccurrences: 3,
  autoTriagEnabled: true,
  criticalKeywords: ['crash', 'down', 'data loss', 'security', 'breach', 'payment failed'],
};
